module.exports = __webpack_public_path__ + "static/makkara_1-f09998b618af56cee3daced48944a3b0.png";